import React from 'react'

interface ITestNavCircle {
    pageNumber: string
    isActive: boolean
}

export const TestNavCircle = ({pageNumber, isActive}:ITestNavCircle) => {
  return (
    <div className={`__nav-circle ${isActive ? "active" : ''}`}>
        {pageNumber}
    </div>
  )
}
